<template>
	<header class="header">
		<div class="container">
			<div class="logo pull-left">
				<a href="index.html">
					<img v-if="systemInfo.company_logo" v-lazy="systemInfo.company_logo" alt="广西百香高科种业有限公司" />
					<!-- <img src="../../assets/img/resources/logo.png" alt="广西百香高科种业有限公司" /> -->

				</a>
			</div>
			<div class="header-right-info pull-right">
				<div class="single-header-info company-email">
					<div class="icon-box">
						<div class="inner-box">
							<i class="flaticon-interface"></i>
						</div>
					</div>
					<div class="content">
						<h3>公司邮箱</h3>
						<p>{{systemInfo.company_email}}</p>
					</div>
				</div>
				<div class="single-header-info company-tel">
					<div class="icon-box">
						<div class="inner-box">
							<i class="flaticon-phone-call"></i>
						</div>
					</div>
					<div class="content">
						<h3>咨询热线</h3>
						<p><b>{{systemInfo.company_mobile}}</b></p>
					</div>
				</div>
				<div class="single-header-info company-wx-qcode">
					<img :src="systemInfo.company_wechat_img" alt="关注微信公众号" />
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</header>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
		name: "page-header",
		computed:{
			...mapGetters(['systemInfo'])
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageHeader.vue